import { OUTCOMES } from '@/constants/common'
import * as R from 'ramda'

export default outcomeId => {
  const outcome = OUTCOMES.find(R.propEq('id', outcomeId))
  return outcome?.label
}
